interface LandingFooterProps {
  countyName: string | null;
}

export default function LandingFooter({ countyName }: LandingFooterProps) {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { label: "About", href: "#about" },
    { label: "Impact", href: "#impact" },
    { label: "Partners", href: "#partners" },
  ];

  return (
    <footer className="bg-gray-900 text-white py-12">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
            {/* Branding */}
            <div className="col-span-1">
              <img
                src="/logo.webp"
                alt="M-Taka"
                width={134}
                height={48}
                className="h-12 w-auto mb-4"
              />
              <p className="text-sm text-gray-400">
                Transforming waste management through technology and innovation
              </p>
            </div>

            {/* Quick Links */}
            <div>
              <h4 className="font-semibold mb-4">Quick Links</h4>
              <ul className="space-y-2">
                {quickLinks.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="text-sm text-gray-400 hover:text-white transition-colors"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Contact */}
            <div>
              <h4 className="font-semibold mb-4">Contact</h4>
              <ul className="space-y-2 text-sm text-gray-400">
                <li>Email: info@m-taka.co.ke</li>
                <li>Location: Nairobi, Kenya</li>
              </ul>
            </div>

            {/* Partnership */}
            <div>
              <h4 className="font-semibold mb-4">Partnership</h4>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-primary flex items-center justify-center text-lg font-bold">
                  M
                </div>
                {countyName && (
                  <>
                    <span className="text-gray-400">×</span>
                    <div className="w-10 h-10 rounded-full bg-orange-500 flex items-center justify-center text-lg font-bold">
                      {countyName[0]}
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>

          {/* Bottom Bar */}
          <div className="pt-8 border-t border-gray-800 text-center text-sm text-gray-400">
            <p>
              © {currentYear}{" "}
              <span className="font-poppins tracking-tighter">
                <span className="font-extrabold text-primary">M</span>
                <span className="font-bold">-taka</span>
              </span>{" "}
              Analytics
              {countyName && ` | ${countyName} County`}
            </p>
            <p className="mt-2">All rights reserved</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
